<template>
  <section class="pb-2">
    <b-col class="d-flex justify-content-between px-0 pt-25">
      <b-button
        v-b-modal.configuration-modal
        variant="primary"
        :disabled="isLoading"
        size="sm"
      >
        <GjIcon
          class="mr-50"
          name="Plus"
        />
        {{ $tk('ClientPortal.Admin.CreateConfigurationItem') }}
      </b-button>
      <SearchInputField
        :disabled="isLoading"
        :placeholder="$tk('Admin.Accounts.Search')"
        @onInputSearch="onSearchChange"
      />
    </b-col>
    <b-card
      class="my-50"
      no-body
    >
      <Table
        :data="configurations"
        :columns="configurationColumns"
        :is-loading="isLoading"
        type-of-table="configurationItems"
        :enable-pagination="false"
      />
      <!-- Add/Edit configuration items -->
      <b-modal
        id="configuration-modal"
        :title="configurationModel.id > 0 ? $tk('ClientPortal.Admin.UpdateConfigurationItem'):$tk('ClientPortal.Admin.CreateConfigurationItem')"
        :ok-title="configurationModel.id > 0 ? $tk('ClientPortal.Form.Actions.Save') : $tk('ClientPortal.Form.Actions.Create')"
        :cancel-title="$tk('ClientPortal.Form.Actions.Cancel')"
        centered
        cancel-variant="outline-secondary"
        no-enforce-focus
        :ok-disabled="saving"
        @show="getConfigurationModel"
        @ok="updateConfiguration"
      >
        <b-form-group
          class="mb-2"
          :label="$tk('ClientPortal.Admin.ConfigurationKey') + ' *'"
          :invalid-feedback="errorMessages['Key']"
        >
          <b-form-input
            v-model="configurationModel.key"
            :placeholder="$tk('ClientPortal.Admin.ConfigurationKeyPlaceholder')"
            :state="errorMessages['Key'] == null ? null : false"
          />
        </b-form-group>
        <b-form-group
          class="mb-0"
          :label="$tk('ClientPortal.Admin.ConfigurationValue') + ' *'"
          :invalid-feedback="errorMessages['Value']"
        >
          <b-form-input
            v-model="configurationModel.value"
            :placeholder="$tk('ClientPortal.Admin.ConfigurationValuePlaceholder')"
            :state="errorMessages['Value'] == null ? null : false"
          />
        </b-form-group>
      </b-modal>
    </b-card>
  </section>
</template>
<script>
import SearchInputField from '@/components/SearchInputField.vue'
import {
  onMounted,
  ref,
  computed,
} from '@vue/composition-api'
import store from '@/store'
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import translation from '@/mixins/translate'
import notification from '@/mixins/toastification'
import Table from '@/components/Table.vue'
import ConfigurationItemsService from '@/api/admin/configurations.service'

export default {
  components: {
    SearchInputField,
    GjIcon,
    Table,
  },
  mixins: [notification],
  setup() {
    const configurationColumns = [
      {
        label: translation.methods.$tk('ClientPortal.Admin.CreateConfigurationItem.Id'),
        field: 'id',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.CreateConfigurationItem.Key'),
        field: 'key',
      },
      {
        label: translation.methods.$tk('ClientPortal.Admin.CreateConfigurationItem.Value'),
        field: 'value',
      },
    ]
    const isLoading = ref(false)
    const configurations = computed(() => store.getters.getAdminConfigurations)
    const configurationModel = ref({})
    const errorMessages = ref({})
    const saving = ref(false)

    onMounted(async () => {
      isLoading.value = true
      await store.dispatch('getAdminConfigurations')
      configurations.value.searchTerm = ''
      isLoading.value = false
    })

    const getConfigurationModel = () => {
      configurationModel.value = store.getters.getConfigurationModel
      errorMessages.value = {}
      store.commit('SET_CONFIGURATION_MODEL', {})
    }

    const onSearchChange = async value => {
      configurations.value.searchTerm = value
    }

    const updateConfiguration = async bvModalEvt => {
      bvModalEvt.preventDefault()
      saving.value = true
      try {
        const response = configurationModel.value.id === 0 ? await ConfigurationItemsService.updateConfiguration(configurationModel.value.id, configurationModel.value) : await ConfigurationItemsService.createConfiguration(configurationModel.value)
        if (response.saved) {
          bvModalEvt.vueTarget.hide('configuration-modal')
          notification.methods.success(response.message)
        } else {
          notification.methods.error(response.message)
          errorMessages.value = response.errors
        }
      } catch (error) {
        notification.methods.error(error.message)
      }
      await store.dispatch('getAdminConfigurations')
      saving.value = false
    }

    return {
      isLoading,
      configurations,
      configurationColumns,
      getConfigurationModel,
      configurationModel,
      onSearchChange,
      updateConfiguration,
      saving,
      errorMessages,
    }
  },
}
</script>
